export const DISMISSED_AI_SUGGESTIONS_KEY = "dismissed-ai-suggestion-map";
